<template>
    <div>
        <v-form ref="form" class="p-2">
           <v-row dense>
                <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <v-textarea
                        v-model="item.comment"
                        :rules="[rules.required]"
                        outlined
                        dense
                        :class="$css_field"
                    >
                        <template v-slot:label>
                            <span :class="$css_field">Comentários</span>
                        </template>
                    </v-textarea>
                </v-col>
           </v-row>
           <v-row dense>       
                <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="text-right">
                    <v-btn
                        color="primary"
                        @click="validate"
                        :class="$css_button"
                    >
                        <span>Adicionar</span>
                    </v-btn>
                </v-col>  
            </v-row>
        </v-form> 
        <v-row v-if="comments" class="mt-3">
            <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">  
                <v-card
                    class="mx-auto"
                    outlined
                >
                    <v-data-table
                        :headers="headers"
                        :items="comments"
                        :items-per-page="10"
                        class="elevation-1 table-striped"
                        :footer-props="{
                        'items-per-page-text':'Itens por página',
                        'items-per-page-options': [5, 10],
                        'items-per-page-all-text': '',
                        'page-text': '{0}-{1} de {2}'
                    }"
                    >
                        <template v-slot:[`item.comment`]="{ item }">
                            <div class="pa-2">
                                <span :class="$css_show_title">{{ item.user }} - {{ formatDateTime(item.created_at) }}</span> <br />
                                <span :class="$css_report_list">{{ item.comment }}</span>
                            </div>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>  
    </div>
</template>

<script>
    export default {
       
        props: {
            object: {
                require: true,
            },
        },

        watch: {
            object: {
                handler() {
                    this.setObject();           // ← configura o formulário com os dados
                },
                immediate: true // ← garante que execute mesmo se já estiver definido
            },
        }, 

        data () {
            return {
                comments: [],

                item: {},

                rules: {
                    required: value => !!value || 'Required.',
                    email: value => /.+@.+/.test(value) || 'E-mail precisa ser válido'
                },

                headers: [
                    { text: 'HISTORICO', align: 'start', value: 'comment', sortable: false },                
                ],
            }
        },

        methods:{   
            setObject(){
                this.comments = this.object.items 
            },

            validate () {
                if (this.$refs.form.validate()) {       
                    this.storeUpdate()
                }
            },
            
            storeUpdate(){
                const item = {}
                if(this.item.id && this.item.id != ''){
                    item.id = this.item.id        
                }else{
                    item.model = this.object.model
                    item.item_id = this.object.item_id    
                }
                item.comment = this.item.comment
            
                const action = item.id ? 'updateComment' : 'storeComment'
                this.$store.dispatch(action, item)
                            .then(response => {
                                const comment = response.data
                                // Verifica se já existe um colaborador com o mesmo id no array
                                const index = this.comments.findIndex(c => c.id === comment.id);

                                if (index > -1) {
                                    // Se existir, substitui
                                    this.$set(this.comments, index, comment);
                                } else {
                                    // Se não existir, adiciona
                                    this.comments.push(comment);
                                }

                                this.comments.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

                                this.$snotify.success('Cadastro com sucesso!')
                                this.reset()
                            })
                            .catch(error => {   
                                this.$snotify.error('Erro no cadastro')
                                this.errors = error.response.data.errors
                            }) 
            },

            editItem (id) {    
                this.$store.dispatch('loadComment', id) 
                            .then(response => {
                                this.item = response.data
                            })
            },

            reset(){
                this.item = {}
                this.$refs.form.reset()
            },

            destroy(item){
                this.$store.dispatch('destroyComment', item.id)
                            .then(response => {
                                this.$emit('callLoadItem',this.object.item_id)
                            })
                            .catch(error => {
                                this.$snotify.error('Erro no cadastro')
                                this.errors = error.response.data.errors
                            })
                            .finally(
                                //this.$snotify.remove()
                                this.$snotify.success('Registro excluído com sucesso!')
                            )
            },
            
        }    
    }
</script>